import React, { useState, useEffect, useContext, useRef } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { TemplateContext } from "../../layout";
import { useForm, Controller } from "react-hook-form";
import CountryField from "../inputs/CountryField";
import RegionField from "../inputs/RegionField";
import TextField from "../inputs/TextField";
import { validationSchema } from "../../func/validation";
import CardField from "../inputs/cardField";
import Button from "../buttons/Button";
import Checkbox from "../inputs/Checkbox";
import PaypalButton from "../buttons/paypalButton";
import CardCvc from "../inputs/cardCvc";
import Accordion from "../accordion";
import questionIcon from "/fallbacks/question-card.svg";
import lockIcon from "/fallbacks/lock-3.svg";
import PaymentsIcon from "/fallbacks/paymentColor.svg";
import LockSvg from "/fallbacks/encryptedLock.svg";
import browserIcon from "/fallbacks/browser.svg";
import paypalIcon from "/fallbacks/paypal-new.svg";
import PhoneField from "../inputs/PhoneField";
import Expiration from "../inputs/Expration";
import MobileSectionSeperator from "../mobileComponents/MobileSectionSeperator";
import WithReach from "../withReach";

const FormAccordionsDivided = ({
  labels,
  headings,
  handleFormSubmit,
  formSubmited,
  initialValues,
  cleanVersion,
  submitFunc,
  compliance,
  reachData,
}) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [country, setCountry] = useState();
  const expirationRef = useRef(null);
  const merchantId = window.general_settings?.merchant_id?.length > 0;
  const base = window.post_template?.checkout_v4_form;
  const formOrder = base?.checkout_v4_payment_method_position;
  const hidePaypalButton = base?.hide_paypal_express_button_block;
  const sslText = base.tr_checkout_v4_formEncrypted;
  const sslTextTop = base.tr_checkout_v4_formEncrypted_top;
  const paypalInnerIcon = headings.checkout_v4_form_paypalInnerIcon
    ? headings.checkout_v4_form_paypalInnerIcon
    : browserIcon;
  const paypalAccordionIcon = headings.checkout_v4_form_paypalCollapseIcon
    ? headings.checkout_v4_form_paypalCollapseIcon
    : paypalIcon;
  const cvcIcon =
    labels.checkout_v4_form_securityCom && labels.tr_checkout_v4_form_securityIcon
      ? labels.tr_checkout_v4_form_securityIcon
      : questionIcon;

  const directAffiliate = window?.affiliate.includes("-direct");
  const showTermsBox = cleanVersion || compliance || directAffiliate;

  const reachOnlyDirectGlobal = window.reach_global?.reach_direct && directAffiliate;
  const formpaymentsGroupClassName =
    formOrder === "top" ? "form_fieldsgroup form_fieldsgroup--withPaddings" : "form_fieldsgroup";
  const formAddressGroupClassName =
    formOrder === "bottom" ? "form_fieldsgroup form_fieldsgroup--withPaddings" : "form_fieldsgroup";
  const reachOnlyIfDirectLocal =
    window.post_template?.checkout_v4_template_reach?.checkout_v4_template_reach_direct && directAffiliate;
  const reachLocal = window.post_template?.checkout_v4_template_reach?.checkout_v4_template_reach_toggle;
  const reachGlobal = window.reach_global.reach_global;

  const displayGlobalBadge = (reachOnlyDirectGlobal || reachGlobal) && !reachLocal && !reachOnlyIfDirectLocal;

  const displayLocalBadge = reachLocal || reachOnlyIfDirectLocal;

  const {
    register,
    setValue,
    handleSubmit,
    control,
    watch,
    getValues,
    trigger,
    formState: { errors, submitCount, values },
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    context: {
      type: {
        method: templateContext?.paymentMethod,
        safe: showTermsBox,
        paypalHandler: templateContext?.paypalHandler,
      },
    },
    mode: "onTouched",
  });

  useEffect(() => {
    if (errors) {
      const errorsvalues = Object.values(errors);
      const types = errorsvalues.map((item) => {
        return item.type;
      });
      const errorOnExpirationField = types.some((type) => type === "test-exp_month" || type === "test-exp_year");
      if (errorOnExpirationField) {
        expirationRef?.current?.scrollIntoView({
          behavior: `smooth`,
          block: "center",
        });
      } else {
        if (errorsvalues.length > 0) {
          let firstErrorElement = document.getElementsByName(errorsvalues[0].ref.name)[0];
          if (firstErrorElement) {
            firstErrorElement?.scrollIntoView({
              behavior: `smooth`,
              block: "center",
            });
          }
        }
      }
    }
  }, [errors]);

  useEffect(() => {
    const { country } = getValues();
    if (country) {
      setCountry(country);
    }
  }, []);

  const formNames = watch(["first_name", "last_name", "expiration"]);

  useEffect(() => {
    if (formNames[0].length > 0 && formNames[1].length > 0) {
      setValue("card_name", `${formNames[0]} ${formNames[1]}`);
    }
    if (formNames[2] && formNames[2].length > 3) {
      const splitedValue = formNames[2].split("/");
      splitedValue[0] && setValue("card_exp_month", splitedValue[0]);
      splitedValue[1] && setValue("card_exp_year", `20${splitedValue[1]}`);
    }
  }, [formNames]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getWidth = () => {
    return windowWidth <= 375 ? "full" : "50";
  };

  const getMargin = () => {
    return windowWidth <= 375 ? false : "12px";
  };

  return (
    <form
      className="paymentMethodNew"
      autoComplete="on"
      onSubmit={handleSubmit((values) => {
        handleFormSubmit(values, templateContext);
      })}
    >
      {hidePaypalButton === false && (
        <PaypalButton
          values={getValues()}
          submitFunc={handleFormSubmit}
          trigger={trigger}
          showTermsBox={showTermsBox}
          formState={errors}
        />
      )}
      <div className="form-order" style={{ display: "flex", flexDirection: "column" }}>
        <div
          id="group-contacts"
          className="form_fieldsgroup--withPaddings"
          style={{ order: formOrder == "top" ? 3 : 1 }}
        >
          {formOrder == "top" && <MobileSectionSeperator margin="0px 0px 16px -16px" />}
          <div className="dividedForm__headings">{headings.tr_checkout_v4_form_informationHeading}</div>
          <div className="dividedForm__contactFields">
            <div className="dividedForm__contactFields__nameFields">
              <Controller
                control={control}
                name="first_name"
                render={({ field: { onChange, value } }) => (
                  <TextField
                    dataCy="first-name-input"
                    type="text"
                    placeholder={labels.tr_checkout_v4_form_nameLabel}
                    name="first_name"
                    fieldName="first_name"
                    width="half"
                    margin="true"
                    autoComplete="cc-given-name"
                    value={value}
                    handleChange={onChange}
                    register={register}
                    error={errors.first_name ? errors.first_name?.message : null}
                    trigger={trigger}
                  />
                )}
              />
              <Controller
                control={control}
                name="last_name"
                render={({ field: { onChange, value } }) => (
                  <TextField
                    dataCy="last-name-input"
                    type="text"
                    placeholder={labels.tr_checkout_v4_form_lastNameLabel}
                    name="last_name"
                    autoComplete="cc-family-name"
                    error={errors.last_name ? errors.last_name?.message : null}
                    width="half"
                    register={register}
                    value={value}
                    handleChange={onChange}
                    trigger={trigger}
                  />
                )}
              />
            </div>
            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, value } }) => (
                <TextField
                  dataCy="email-input"
                  type="email"
                  placeholder={labels.tr_checkout_v4_form_emailLabel}
                  name="email"
                  width="full"
                  error={errors.email ? errors.email.message : null}
                  register={register}
                  value={value}
                  handleChange={onChange}
                  trigger={trigger}
                />
              )}
            />
            <Controller
              control={control}
              name="phone"
              render={({ field: { onChange, value } }) => (
                <PhoneField value={value} error={errors.phone ? errors.phone.message : null} handleChange={onChange} />
              )}
            ></Controller>
          </div>
        </div>
        <div id="group-delivery" className={formAddressGroupClassName} style={{ order: formOrder === "top" ? 3 : 2 }}>
          <MobileSectionSeperator margin="0px 0px 16px -16px" />
          <div className="dividedForm__headings">{headings.tr_checkout_v4_form_shippingHeading}</div>
          <div className="dividedForm__deliveryFields">
            <Controller
              control={control}
              name="country"
              render={({ field: { onChange, value } }) => (
                <CountryField
                  label={labels.tr_checkout_v4_form_countryLabel}
                  name="country"
                  error={errors.country ? errors.country.message : null}
                  value={value}
                  handleChange={(e) => {
                    onChange(e);
                    setCountry(e);
                  }}
                />
              )}
            />
            <Controller
              control={control}
              name="address"
              render={({ field: { onChange, value } }) => (
                <TextField
                  dataCy="adress-input"
                  type="text"
                  placeholder={labels.tr_checkout_v4_form_addressLabel}
                  error={errors.address ? errors.address.message : null}
                  name="address"
                  autoComplete="street-address"
                  width="full"
                  register={register}
                  value={value}
                  handleChange={onChange}
                  trigger={trigger}
                />
              )}
            />
            <div className="dividedForm__deliveryFields__triple">
              <Controller
                control={control}
                name="city"
                render={({ field: { onChange, value } }) => (
                  <TextField
                    dataCy="city-input"
                    type="text"
                    placeholder={labels.tr_checkout_v4_form_cityLabel}
                    name="city"
                    register={register}
                    width="full"
                    autoComplete="address-level2"
                    error={errors.city ? errors.city.message : null}
                    value={value}
                    handleChange={onChange}
                    trigger={trigger}
                  />
                )}
              />

              <Controller
                control={control}
                name="state"
                render={({ field: { onChange, value } }) => (
                  <RegionField
                    label={labels.tr_checkout_v4_form_stateLabel}
                    error={errors.state ? errors.state.message : null}
                    country={country || window.countryCode.toUpperCase()}
                    handleChange={onChange}
                    value={value}
                    defaultLabel={labels?.tr_checkout_v4_form_stateLabel}
                  />
                )}
              />
              <Controller
                control={control}
                name="zip"
                render={({ field: { onChange, value } }) => (
                  <TextField
                    dataCy="zip-input"
                    type="text"
                    placeholder={labels.tr_checkout_v4_form_postLabel}
                    error={errors.zip ? errors.zip.message : null}
                    name="zip"
                    width="full"
                    register={register}
                    autoComplete="postal-code"
                    value={value}
                    handleChange={onChange}
                    trigger={trigger}
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div id="group-payments" className={formpaymentsGroupClassName} style={{ order: formOrder === "top" ? 1 : 3 }}>
          {formOrder != "top" && <MobileSectionSeperator margin="0px 0px 16px -16px" />}
          <div className="dividedForm__headings payment">{headings.tr_checkout_v4_form_methodsHeading}</div>
          <div className="dividedForm__headings payment__subText">{sslTextTop}</div>
          <div className="accordionContainer" ref={expirationRef}>
            <Accordion
              label={headings.tr_checkout_v4_form_cardCollapseHeading}
              image={
                headings.checkout_v4_form_cardCollapseIcon ? headings.checkout_v4_form_cardCollapseIcon : PaymentsIcon
              }
              name="card"
              defaultState={true}
              overflow={templateContext?.paymentMethod == "card" ? true : null}
            >
              <Controller
                control={control}
                name="card_number"
                render={({ field: { onChange, value } }) => (
                  <CardField
                    dataCy="card-input"
                    type="tel"
                    name="card_number"
                    icon={lockIcon}
                    comment={labels.tr_checkout_v4_form_cardComment}
                    width="full"
                    placeholder={labels.tr_checkout_v4_form_cardNumberLabel}
                    error={errors.card_number ? errors.card_number.message : null}
                    value={value}
                    register={register}
                    setValue={setValue}
                    submitCount={submitCount}
                  />
                )}
              />
              <Controller
                control={control}
                name="expiration"
                ref={expirationRef}
                render={({ field: { onChange, value } }) => (
                  <Expiration
                    dataCy="expiration-input"
                    type="tel"
                    name="expiration"
                    width={getWidth()}
                    register={register}
                    value={value}
                    max={5}
                    trigger={trigger}
                    handleChange={onChange}
                    placeholder={labels.tr_checkout_v4_form_expirationLabel}
                    margin={getMargin()}
                    error={
                      errors.card_exp_year || errors.card_exp_month
                        ? errors.card_exp_year?.message || errors.card_exp_month?.message
                        : null
                    }
                  />
                )}
              />

              <Controller
                control={control}
                name="card_cvc"
                render={({ field: { onChange, value } }) => (
                  <CardCvc
                    type="tel"
                    max={4}
                    min={1}
                    name="card_cvc"
                    register={register}
                    submitCount={submitCount}
                    icon={cvcIcon}
                    comment={labels.checkout_v4_form_securityCom && labels.tr_checkout_v4_form_securityComment}
                    width={getWidth()}
                    setValue={setValue}
                    placeholder={labels.tr_checkout_v4_form_securityLabel}
                    error={errors.card_cvc ? errors.card_cvc?.message : null}
                    value={value}
                    handleChange={onChange}
                  />
                )}
              />
              {displayGlobalBadge && merchantId && (
                <WithReach environment="global" type="accordion" text={reachData?.Html} image={reachData?.ImageUrl} />
              )}
            </Accordion>
            <Accordion defaultState={false} maxImgWidth={90} imageHeight={24} image={paypalAccordionIcon} name="paypal">
              <span
                className="paypalRadio__image"
                style={{
                  backgroundImage: `url('${paypalInnerIcon}')`,
                  margin: "0 auto",
                  marginBottom: "16px",
                }}
              ></span>
              <p className="paypalRadio__text">{headings.tr_checkout_v4_form_paypalInner}</p>
            </Accordion>
          </div>
          {displayLocalBadge && merchantId && (
            <div className="with-reach-container">
              <WithReach
                environment="local"
                type="accordion"
                onlyDirectGlobal={reachOnlyDirectGlobal}
                onlyDirectLocal={reachOnlyIfDirectLocal}
                text={reachData?.Html}
                image={reachData?.ImageUrl}
              />
            </div>
          )}
        </div>
      </div>
      {showTermsBox && (
        <Controller
          control={control}
          name="policy"
          render={({ field: { onChange, value } }) => (
            <Checkbox
              error={errors?.policy ? errors?.policy?.message : null}
              value={value}
              register={register}
              trigger={trigger}
              handleChange={onChange}
              name="policy"
              margin={"16px 0px 0px"}
            />
          )}
        />
      )}
      {templateContext?.paymentMethod == "card" ? (
        <Button
          id="hook-form"
          type="submit"
          margin={16}
          text={base?.tr_checkout_v4_form_cta}
          processingLabel={base?.tr_checkout_v4_form_processing}
          loading={formSubmited}
        />
      ) : (
        <PaypalButton
          text={base?.tr_checkout_v4_form_paypalText}
          submitFunc={submitFunc}
          modifications={{ noBorders: true }}
          trigger={trigger}
          showTermsBox={showTermsBox}
          formState={errors}
          margin={cleanVersion ? 16 : 0}
        />
      )}
      <div className="paymentIcons">
        <div className="paymentIcons__text">
          <span
            style={{
              backgroundImage: `url(${LockSvg})`,
            }}
          ></span>
          <span>{sslText}</span>
        </div>
      </div>
    </form>
  );
};

export default FormAccordionsDivided;
